import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import AabInputMessage from '@aab/sc-aab-inputmessage/src/AabInputmessage';
import Styles from './styles.scss';

export default class AabInput extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    // Initialize LitElement properties here
    this.iconPosition = '';
  }

  static get properties() {
    return {
      prepend: { type: String },
      iconPosition: { type: String, attribute: 'icon-position' },
      message: { type: String },
      messageType: { type: String, attribute: 'message-type' },
    };
  }

  static get scopedElements() {
    return {
      'aab-inputmessage': AabInputMessage,
    };
  }

  static get styles() {
    return [Styles];
  }

  firstUpdated() {
    const iconElNodes = this.shadowRoot.querySelector('slot[name="icon"]').assignedNodes();

    const inputSlot = this.shadowRoot.querySelector('slot:not([name])');
    const inputElement = inputSlot.assignedNodes().find((node) => node.nodeName === 'INPUT');

    if (iconElNodes.length > 0) {
      // If an node is found, we will start listening to changes on the disabled attribute
      const observer = new MutationObserver(() => {
        iconElNodes[0].style.filter = inputElement?.disabled ? 'grayscale(100%) opacity(50%)' : '';
      });

      observer.observe(inputElement, { attributes: true, attributeFilter: ['disabled'] });
      iconElNodes[0].style.filter = inputElement?.disabled ? 'grayscale(100%) opacity(50%)' : '';
    }
  }

  render() {
    return html`
      <span class="label">
        <slot name="label"></slot>
      </span>
      <div class="input-group icon-position-${this.iconPosition} ${this.messageType} ${this.prepend ? 'prepended' : ''}">
        ${this.prepend ? html`<div class="input-group-prepend"><span class="input-group-text p-1">${this.prepend}</span></div>` : ''}
        <slot></slot>
        <div class="input-icon"><slot name="icon"></slot></div>
      </div>
      ${this.message ? html`<aab-inputmessage class="mt-1 d-block" message=${this.message} type=${this.messageType} icon></aab-inputmessage>` : ''}
    `;
  }
}
